
export default {
  name: 'RuleNav',
  props: {
    active: {
      type: String,
      default: 'enveloperule',
    },
  },
  methods: {},
}
